import i18n from 'modules/core/lib/i18n'
import { buildNavigation } from 'modules/core/lib/react-router'

import { financeAccountingRoutes } from './modularNavigation/accounting'
import {
  legacyFinanceRedirectRoutes,
  legacySpendingProductsRedirectRoutes,
} from './modularNavigation/legacyRedirects'
import { financeSalesRoutes } from './modularNavigation/sales'
import { financeSpendingRoutes } from './modularNavigation/spending'
import { financeTreasuryRoutes } from './modularNavigation/treasury'
import { financeWorkspaceRoutes } from './workspace'

export const financeModularRoutes = buildNavigation((navigation) => {
  return [
    {
      path: navigation.finance.path,
      handle: {
        module: 'finance-workspace',
        moduleName: () => i18n.t('finance.navigator.description'),
      },
      children: [
        ...financeWorkspaceRoutes(navigation),

        ...financeSpendingRoutes(navigation),
        ...financeAccountingRoutes(navigation),
        ...financeSalesRoutes(navigation),
        ...financeTreasuryRoutes(navigation),
        ...legacyFinanceRedirectRoutes(navigation),
      ],
    },
    ...legacySpendingProductsRedirectRoutes(navigation),
  ]
})
